export const downloadFile = (signedUrl, filename = "download") => {
  const a = document.createElement("a");
  a.href = signedUrl;
  a.setAttribute("download", filename);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
